import { render, staticRenderFns } from "./SupplierEditDialog.vue?vue&type=template&id=279c78d8&scoped=true"
import script from "./SupplierEditDialog.vue?vue&type=script&lang=ts"
export * from "./SupplierEditDialog.vue?vue&type=script&lang=ts"
import style0 from "./SupplierEditDialog.vue?vue&type=style&index=0&id=279c78d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279c78d8",
  null
  
)

export default component.exports